export const SET_FACTORY_LIST = (state, factories) => {
    state.factoryList = factories;
};

export const SET_MAIN_SELECTED_TAB = (state, tabName) => {
    state.selectedTab = tabName;
};

export const SET_TABLE_CONTROL = (state, control) => {
    state.tableLoadControl = {
        warehouseList: control.warehouseList ?? state.tableLoadControl.warehouseList,
        factoryList: control.factoryList ?? state.tableLoadControl.factoryList,
        portList: control.portList ?? state.tableLoadControl.portList
    };
};

export const SET_FACTORY_TOTALIZER = (state, totalizerInfo) => {
    state.totalizers = totalizerInfo;
};

export const SET_FACTORY_FILTER = (state, filter) => {
    state.factoryFilter = {
        page: filter.page ?? state.factoryFilter.page,
        size: filter.size ?? state.factoryFilter.size
    };
};

export const SET_SEARCH_TEXT = (state, searchText) => {
    state.searchText = searchText ?? state.searchText;
};

export const SET_PORT_TOTALIZER = (state, totalizerInfo) => {
    state.portTotalizers = totalizerInfo;
};

export const SET_PORT_LIST = (state, ports) => {
    state.portList = ports;
};

export const SET_PORT_FILTER = (state, filter) => {
    state.portFilter = {
        page: filter.page ?? state.portFilter.page,
        size: filter.size ?? state.portFilter.size,
        portId: filter.portId ?? state.portFilter.portId
    };
};

export const SET_LOAN_TOTALIZER = (state, totalizerInfo) => {
    state.loanTotalizers = totalizerInfo;
};

export const SET_LOAN_TOTALIZER_MODAL = (state, totalizerInfo) => {
    state.loanTotalizersModal = totalizerInfo;
};

export const SET_LOAN_COMPANY_LIST = (state, companyList) => {
    state.loanCompanyList = companyList;
};

export const SET_LOANS_LIST = (state, loans) => {
    state.loansList = loans;
};
